export default __webpack_public_path__ + "static/media/MaskGroup331.c7838e00.png";